import { RootState } from 'store';

const selectInn = (state: RootState): string[] => state.inn.data;
export default selectInn;
